const StyleComment = (comment) => {
  const symbols = ['⊕', '▲', '★', '￡', '◆', '▼', '￥', '￠', '@', '&'];

  const lines = comment.split('\n');

  const formatted = lines.map((line) => {
    const trimmed = line.trim();

    const isTitle = symbols.some(
      (sym) => trimmed.startsWith(sym) && trimmed.endsWith(sym) && trimmed.length >= 2
    );

    return isTitle ? trimmed : line;
  });

  return formatted.join('\n');
};
// const StyleComment = (comment) => {
//   const symbols = ['⊕', '▲', '★', '￡', '◆', '▼', '￥', '￠', '@', '&'];

//   const lines = comment.split('\n');

//   const formatted = lines.map((line) => {
//     const trimmed = line.trim();

//     const isTitle = symbols.some(
//       (sym) => trimmed.startsWith(sym) && trimmed.endsWith(sym) && trimmed.length >= 2
//     );

//     return isTitle ? `${trimmed}\n` : line;
//   });

//   return formatted.join('\n');
// };

export default StyleComment;
// const StyleComment = (comment) => {
//     comment = comment.replace(/(⊕.*?⊕)/, '$1\n');
//     comment = comment.replace(/(▲.*?▲)/, '$1\n');
//     comment = comment.replace(/(★.*?★)/, '$1\n');
//     comment = comment.replace(/(￡.*?￡)/, '$1\n');
//     comment = comment.replace(/(◆.*?◆)/, '$1\n');
//     comment = comment.replace(/(▼.*?▼)/, '$1\n');
//     comment = comment.replace(/(￥.*?￥)/, '$1\n');
//     comment = comment.replace(/(￠.*?￠)/, '$1\n');

//     comment = comment.replace(/(.*?)▲/, '$1\n▲');
//     comment = comment.replace(/(.*?)★/, '$1\n★');
//     comment = comment.replace(/(.*?)￡/, '$1\n￡');
//     comment = comment.replace(/(.*?)◆/, '$1\n◆');
//     comment = comment.replace(/(.*?)▼/, '$1\n▼');
//     comment = comment.replace(/(.*?)￥/, '$1\n￥');
//     comment = comment.replace(/(.*?)￠/, '$1\n￠');
//     return comment;
// }

// export default StyleComment;